import { call, put, takeEvery} from "redux-saga/effects";
import {
  GET_APPLICATION_STATUS_DEF,
} from "./actionTypes"

import {

  getApplicationStatusDefSuccess,
  applicationStatusDefError
  
} from "./actions"

//Include Both Helper File with needed methods
import {
getApplicationStatusDef

} from "../../helpers/backend_helper/backend_helper"

function* get_ApplicationStatusDef() {
  try {
    const response = yield call(getApplicationStatusDef)
    yield put(getApplicationStatusDefSuccess(response))
  } catch (error) {
    yield put(applicationStatusDefError(error))
  }
}

function* applicationStatusDefManagementSaga() {

    yield takeEvery(GET_APPLICATION_STATUS_DEF,get_ApplicationStatusDef)
}

export default applicationStatusDefManagementSaga
